import BaseService from "./geral/BaseService";

const base = "AcompanhamentoProcesso";
const baseSolicitacao = "SolicitacaoDesovaPier";

export default class AcompanhamentoProcessoService extends BaseService {

    constructor(props) {
        super(props)
    }

    ListarDespachantePorUsuario = () => {
        return super.httpGet(`/${base}/ListarDespachantePorUsuario`)
    }

    ListarTipoProcesso = () => {
        return super.httpGet(`/${base}/ListarTipoProcesso`)
    }


    ListarNavioPorCe = (cte ="") => {
        return super.httpGet(`/${base}/ListarNavioPorCe?cte=${cte}`);
    }

    ListarProcessos = (doc = "") => {
        return super.httpGet(`/${base}/ListarProcesso?documento=${doc}`)
    }

    SalvarAverbacao = (despId, tipoProc, numBl, numDI, deAcordo) => {
        return super.httpGet(`/${base}/SalvarAverbacao?despachanteId=${despId}&tipoProcesso=${tipoProc}&numeroBL=${numBl}&numeroDI=${numDI}&deAcordo=${deAcordo}`)
    }

    DesistirVistoria = (docId) => {
        return super.httpGet(`/${base}/DesistirVistoriaSsa?docId=${docId}`);
    }

    Relatorio = (numBl, navio = "") => {
        return super.httpGet(`/${base}/Relatorio?numeroBl=${numBl}&navio=${navio}`)
    }
    
    RelatorioDetalhado = (documento, vesselVisitId = "") => {
        return super.httpGet(`/${base}/RelatorioDetalhado?documento=${documento}&vesselVisitId=${vesselVisitId}`)
    }


    buscarDesovaPorBL = (documento) => {
        return super.httpGet(`${base}/BuscarDesovaPorDocumento?bl=${documento}`);
    }
}



// WEBPACK FOOTER //
// ./src/services/AcompanhamentoProcessoService.js